import CreateFirstDashboard from './CreateFirstDashboard';

export default CreateFirstDashboard;
